import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Toggle from '../../../components/common/toggleButton';
import { Select } from '../form-fields/Select';

export interface TextAlignProps {
  value: ITextAlignProps;
  onChange: (_value: ITextAlignProps) => void;
  title: string;
}
export const textAlignProps = {
  textAlign: {
    deviceType: 'desktop',
    align: {
      desktop: 'text-center',
      tablet: 'text-start',
      mobile: 'text-start',
    },
  },
};

export interface ITextAlignProps {
  deviceType: string;
  align: {
    mobile: string;
    tablet: string;
    desktop: string;
  };
}

export const AlignmentOptions = [
  { label: 'Left', value: 'text-left' },
  { label: 'Center', value: 'text-center' },
  { label: 'Right', value: 'text-right' },
  { label: 'Justify', value: 'text-justify' },
];

const TextAlign: React.FC<TextAlignProps> = ({ onChange, value, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 mt-3  border border-gray-300 rounded p-2 w-full">
          <Toggle<ITextAlignProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <Select
            className="pagebuilder-theme"
            value={value.align?.[value.deviceType as keyof typeof value.align]}
            onChange={e =>
              onChange({
                ...value,
                align: {
                  ...value.align,
                  [value.deviceType]: e.target.value,
                },
              })
            }
            options={AlignmentOptions}
            label="Text Alignment"
          />
        </div>
      )}
    </div>
  );
};
export default TextAlign;
